import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

const RIGCHECK_ROOT = "Rigchecks/VgTv80ik2BtavT0A5owc";

function sourceCollection(agency, source) {
  if (source === "fleet") return collection(db, "Agencies", agency, "FleetTrack");
  if (source === "units") return collection(db, "Agencies", agency, "units");
  return collection(db, RIGCHECK_ROOT, `${agency} Rigchecks`);
}

function statusOf(u) {
  if (u.outOfService || u.status === "Out of Service") return { label: "OOS", cls: "oos" };
  if (u.inService === false) return { label: "OOS", cls: "oos" };
  return { label: "In Service", cls: "in" };
}

// Apparatus / unit availability from the board's configured unit source.
const UnitStatusWidget = ({ config = {}, agency, board }) => {
  const [units, setUnits] = useState([]);
  const source = config.unitDataSource || board?.dataSources?.unitDataSource || "rigcheck";

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      sourceCollection(agency, source),
      (snap) => {
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((u) => !u.disabled)
          .map((u) => ({ ...u, _name: u.label || u.unitNumber || u.name || u.id }))
          .sort((a, b) => String(a._name).localeCompare(String(b._name), undefined, { numeric: true }));
        setUnits(list);
      },
      (err) => console.warn("unit status load failed", err)
    );
    return () => unsub();
  }, [agency, source]);

  return (
    <WidgetShell title="Apparatus Status">
      {units.length === 0 ? (
        <EmptyState icon="🚒" label="No units found." />
      ) : (
        <div className="sb-unit-grid">
          {units.map((u) => {
            const s = statusOf(u);
            return (
              <div className={`sb-unit ${s.cls}`} key={u.id}>
                <span className="sb-unit-name">{u._name}</span>
                <span className="sb-unit-status">{s.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </WidgetShell>
  );
};

export default UnitStatusWidget;
